import { render, staticRenderFns } from "./AnalyticsCongratulationJohn.vue?vue&type=template&id=35cfefce&scoped=true&"
var script = {}
import style0 from "./AnalyticsCongratulationJohn.vue?vue&type=style&index=0&id=35cfefce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cfefce",
  null
  
)

export default component.exports